import { RootPlugs } from "slot-definitions"
import { MessageProgramLoader } from "./message-program-loader"

RootPlugs.plug(<MessageProgramLoader />)
